// extracted by mini-css-extract-plugin
export var modalFooter = "_ph-0";